<div class="modal-header">
  <h3 class="modal-title">
    {{ modalTitle }}
    <i (click)="cancel()" class="fa fa-times pull-right"></i>
    <i class="fa pull-right"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px"
       (click)="toggleMinimize()"></i>
  </h3>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (showEntityLoader) {
    <div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
  } @else {
    <div class="panel panel-default">
      <div class="panel-heading">
        <h4><b>EC Quarter Map Details:</b></h4>
      </div>
      <div class="panel-body">
        <form [formGroup]="quarterMapForm">
          @if (isEditMode) {
            <div class="row">
              <div class="col-md-3">
                <ng-container [ngTemplateOutlet]="taxYearField"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container [ngTemplateOutlet]="groupObjectField"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container [ngTemplateOutlet]="reportingPeriodField"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container [ngTemplateOutlet]="taxYearEndField"></ng-container>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <ng-container [ngTemplateOutlet]="filingCycleField"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container [ngTemplateOutlet]="fromTaxYearField"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container [ngTemplateOutlet]="fromReportingPeriodField"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container [ngTemplateOutlet]="taxYearBeginField"></ng-container>
              </div>
            </div>
          } @else {
            <div class="row">
              <div class="col-md-3">
                <ng-container [ngTemplateOutlet]="taxYearField"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container [ngTemplateOutlet]="scenarioTypeField"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container [ngTemplateOutlet]="scenarioDescField"></ng-container>
              </div>
              <div class="col-md-3">
                <ng-container [ngTemplateOutlet]="groupObjectField"></ng-container>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="reportingPeriodField"></ng-container>
              </div>
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="taxYearEndField"></ng-container>
              </div>
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="filingCycleField"></ng-container>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="fromTaxYearField"></ng-container>
              </div>
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="fromReportingPeriodField"></ng-container>
              </div>
              <div class="col-md-4">
                <ng-container [ngTemplateOutlet]="taxYearBeginField"></ng-container>
              </div>
            </div>
          }

          <ng-template #taxYearField>
            <div class="form-group">
              <label for="tax-year"><b>Tax Year<sup>*</sup>:</b></label>
              <input id="tax-year" type="text" class="form-control"
                     formControlName="TAX_YEAR" readonly>
              @if (quarterMapForm.get('TAX_YEAR')?.invalid && quarterMapForm.get('TAX_YEAR')?.touched) {
                <small class="text-danger">Please provide Tax Year</small>
              }
            </div>
          </ng-template>

          <ng-template #scenarioTypeField>
            <div class="form-group">
              <label for="scenario-type-code"><b>Scenario Type Code<sup>*</sup>:</b></label>
              <select id="scenario-type-code" class="form-control"
                      formControlName="SCENARIO_TYPE_CODE"
                      (change)="onScenarioTypeCodeChange()">
                <option value="">Select Scenario Type Code</option>
                @for (item of allscenarioTypeCode; track $index) {
                  <option [value]="item.SCENARIO_TYPE_CODE">{{ item.SCENARIO_TYPE_CODE }}</option>
                }
              </select>
              @if (quarterMapForm.get('SCENARIO_TYPE_CODE')?.invalid && quarterMapForm.get('SCENARIO_TYPE_CODE')?.touched) {
                <small class="text-danger">Please provide Scenario Type Code</small>
              }
            </div>
          </ng-template>

          <ng-template #scenarioDescField>
            <div class="form-group">
              <label for="scenario-desc"><b>Scenario Desc<sup>*</sup>:</b></label>
              <select id="scenario-desc" class="form-control"
                      formControlName="SCENARIO_DESC"
                      (change)="onPopulateGroupObjYear()">
                <option value="">Select Scenario Description</option>
                @for (item of allscenarioDesc; track $index) {
                  <option [value]="item.SCENARIO_VALUE">{{ item.SCENARIO_DESC }}</option>
                }
              </select>
              @if (quarterMapForm.get('SCENARIO_DESC')?.invalid && quarterMapForm.get('SCENARIO_DESC')?.touched) {
                <small class="text-danger">Please provide Scenario Desc</small>
              }
            </div>
          </ng-template>

          <ng-template #groupObjectField>
            <div class="form-group">
              <label for="gok"><b>Group Object Key<sup>*</sup>:</b></label>
              @if (isEditMode) {
                <input id="gok" type="text" class="form-control"
                       formControlName="GROUP_OBJ_KEY" readonly>
              } @else {
                <select id="gok" class="form-control" formControlName="GROUP_OBJ_KEY">
                  <option value="">Select Group Object Key</option>
                  @for (item of allGroupObjByYear; track $index) {
                    <option [value]="item.GROUP_OBJ_KEY">{{ item.GROUP_OBJ_KEY }}</option>
                  }
                </select>
              }
              @if (quarterMapForm.get('GROUP_OBJ_KEY')?.invalid && quarterMapForm.get('GROUP_OBJ_KEY')?.touched) {
                <small class="text-danger">Please provide Group Object Key</small>
              }
            </div>
          </ng-template>

          <ng-template #reportingPeriodField>
            <div class="form-group">
              <label for="reportingPeriodList"><b>Reporting Period<sup>*</sup>:</b></label>
              @if (isEditMode) {
                <input id="reportingPeriodList" type="text" class="form-control"
                       formControlName="RPT_MTH" readonly>
              } @else {
                <select id="reportingPeriodList" class="form-control" formControlName="RPT_MTH">
                  <option value="">Select Reporting Period</option>
                  <option value="3">3</option>
                  <option value="6">6</option>
                  <option value="9">9</option>
                  <option value="12">12</option>
                </select>
              }
              @if (quarterMapForm.get('RPT_MTH')?.invalid && quarterMapForm.get('RPT_MTH')?.touched) {
                <small class="text-danger">Please provide Reporting Period</small>
              }
            </div>
          </ng-template>

          <ng-template #taxYearEndField>
            <div class="form-group">
              <label for="taxYearEnd"><b>Tax Year End<sup>*</sup>:</b></label>
              @if (isEditMode) {
                <div class="input-group date-input-group">
                  <input id="taxYearEnd" type="text" class="form-control"
                         formControlName="TAX_YEAR_END" readonly>
                  <span class="input-group-addon"
                        (click)="openNativeDatePicker(taxYearEndPicker, quarterMapForm.get('TAX_YEAR_END')?.value)">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
                <input #taxYearEndPicker type="date" class="native-date-trigger" tabindex="-1"
                       (change)="onCalendarDateSelected('TAX_YEAR_END', $event)">
              } @else {
                <input id="taxYearEnd" type="date" class="form-control"
                       formControlName="TAX_YEAR_END">
              }
              @if (quarterMapForm.get('TAX_YEAR_END')?.invalid && quarterMapForm.get('TAX_YEAR_END')?.touched) {
                <small class="text-danger">Please provide Tax Year End date</small>
              }
            </div>
          </ng-template>

          <ng-template #filingCycleField>
            <div class="form-group">
              <label for="filingCycle"><b>Filing Cycle<sup>*</sup>:</b></label>
              <input id="filingCycle" class="form-control"
                     [attr.list]="isEditMode ? null : 'filingCycleList'"
                     placeholder="Select Filing Cycle"
                     formControlName="FILING_CYCLE"
                     [readonly]="!!isEditMode">
              @if (!isEditMode) {
                <datalist id="filingCycleList">
                  @for (item of allFilingCycle; track $index) {
                    <option [value]="item.FILING_CYCLE">{{ item.FILING_CYCLE }}</option>
                  }
                </datalist>
              }
              @if (quarterMapForm.get('FILING_CYCLE')?.invalid && quarterMapForm.get('FILING_CYCLE')?.touched) {
                <small class="text-danger">Please provide Filing Cycle</small>
              }
            </div>
          </ng-template>

          <ng-template #fromTaxYearField>
            <div class="form-group">
              <label for="fromYear"><b>From Tax Year<sup>*</sup>:</b></label>
              @if (isEditMode) {
                <div class="input-group date-input-group">
                  <input id="fromYear" type="text" class="form-control"
                         formControlName="FROM_TAX_YEAR" readonly>
                  <span class="input-group-addon" (click)="openFromYearPicker()">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
                <gtw-year-picker-popup
                  [selectedYear]="fromTaxYearNumber"
                  [showPopup]="showFromYearPicker"
                  [minYear]="1900"
                  [maxYear]="9999"
                  [triggerElementId]="'fromYear'"
                  (yearSelected)="onFromYearSelected($event)"
                  (popupClosed)="closeFromYearPicker()">
                </gtw-year-picker-popup>
              } @else {
                <input id="fromYear" type="number" class="form-control"
                       formControlName="FROM_TAX_YEAR"
                       min="1900" max="2100" placeholder="YYYY"
                       (change)="onFromTaxYearChange()">
              }
              @if (quarterMapForm.get('FROM_TAX_YEAR')?.invalid && quarterMapForm.get('FROM_TAX_YEAR')?.touched) {
                <small class="text-danger">Please provide From Tax Year</small>
              }
            </div>
          </ng-template>

          <ng-template #fromReportingPeriodField>
            <div class="form-group">
              <label for="fromReportingPeriodList"><b>From Reporting Period<sup>*</sup>:</b></label>
              @if (isEditMode) {
                <input id="fromReportingPeriodList" type="text" class="form-control"
                       formControlName="FROM_RPT_MTH" readonly>
              } @else {
                <select id="fromReportingPeriodList" class="form-control" formControlName="FROM_RPT_MTH">
                  <option value="">Select From Reporting Period</option>
                  <option value="3">3</option>
                  <option value="6">6</option>
                  <option value="9">9</option>
                  <option value="12">12</option>
                </select>
              }
              @if (quarterMapForm.get('FROM_RPT_MTH')?.invalid && quarterMapForm.get('FROM_RPT_MTH')?.touched) {
                <small class="text-danger">Please provide From Reporting Period</small>
              }
            </div>
          </ng-template>

          <ng-template #taxYearBeginField>
            <div class="form-group">
              <label for="taxYearBegin"><b>Tax Year Begin<sup>*</sup>:</b></label>
              @if (isEditMode) {
                <div class="input-group date-input-group">
                  <input id="taxYearBegin" type="text" class="form-control"
                         formControlName="TAX_YEAR_BEGIN" readonly>
                  <span class="input-group-addon"
                        (click)="openNativeDatePicker(taxYearBeginPicker, quarterMapForm.get('TAX_YEAR_BEGIN')?.value)">
                    <i class="fa fa-calendar"></i>
                  </span>
                </div>
                <input #taxYearBeginPicker type="date" class="native-date-trigger" tabindex="-1"
                       (change)="onCalendarDateSelected('TAX_YEAR_BEGIN', $event)">
              } @else {
                <input id="taxYearBegin" type="date" class="form-control"
                       formControlName="TAX_YEAR_BEGIN">
              }
              @if (quarterMapForm.get('TAX_YEAR_BEGIN')?.invalid && quarterMapForm.get('TAX_YEAR_BEGIN')?.touched) {
                <small class="text-danger">Please provide Tax Year Begin</small>
              }
            </div>
          </ng-template>
        </form>
      </div>
    </div>
  }
</div>

<div class="modal-footer" [hidden]="minimise">
  @if (!isEditMode) {
    <button class="save-button" type="button" (click)="save()" [disabled]="crudLoading">
      Create
      @if (crudLoading) {
        <span><i class="fa fa-spinner fa-pulse"></i></span>
      }
    </button>
    <button class="reset-button" type="button" (click)="reset()">Reset</button>
  } @else {
    <!-- Update is hidden. Legacy edit calls ctrl.save(false), but ecQuarterMapUpdateActionsController does not define save. Confirm the update action with the leads before enabling this button. -->
    <button class="delete-button" type="button" (click)="delete()" [disabled]="deleteLoading">
      Delete
      @if (deleteLoading) {
        <span><i class="fa fa-spinner fa-pulse"></i></span>
      }
    </button>
  }
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
